import { gql } from 'apollo-angular';

export const GenerateAyrshareAccountUrlDocument = gql`
  query generateAyrshareAccountUrl {
    generateAyrshareAccountUrl
  }
`;
